import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  deleteObj,
  modifyRemark,
  addProcessRemark,
  batchAddProcessRemark,
} from '@/api/duplicateterminalnumanalysisresultserv'

export default {
  state: {
    state_DuplicateTerminalNumAnalysisResult_GetAllResult: null,
    state_DuplicateTerminalNumAnalysisResult_SearchByNameResult: null,
    state_DuplicateTerminalNumAnalysisResult_GetPageResult: null,
    state_DuplicateTerminalNumAnalysisResult_GetDetailResult: null,
    state_DuplicateTerminalNumAnalysisResult_DeleteObjResult: null,
    state_DuplicateTerminalNumAnalysisResult_ModifyRemarkResult: null,
    state_DuplicateTerminalNumAnalysisResult_AddProcessRemarkResult: null,
    state_DuplicateTerminalNumAnalysisResult_BatchAddProcessRemarkResult: null,
  },
  mutations: {
    SET_DUPLICATETERMINALNUMANALYSISRESULT_GETALL_RESULT: (state, rst) => {
      state.state_DuplicateTerminalNumAnalysisResult_GetAllResult = rst;
    },
    SET_DUPLICATETERMINALNUMANALYSISRESULT_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_DuplicateTerminalNumAnalysisResult_SearchByNameResult = rst;
    },
    SET_DUPLICATETERMINALNUMANALYSISRESULT_GETPAGE_RESULT: (state, rst) => {
      state.state_DuplicateTerminalNumAnalysisResult_GetPageResult = rst;
    },
    SET_DUPLICATETERMINALNUMANALYSISRESULT_GETDETAIL_RESULT: (state, rst) => {
      state.state_DuplicateTerminalNumAnalysisResult_GetDetailResult = rst;
    },
    SET_DUPLICATETERMINALNUMANALYSISRESULT_DELETEOBJ_RESULT: (state, rst) => {
      state.state_DuplicateTerminalNumAnalysisResult_DeleteObjResult = rst;
    },
    SET_DUPLICATETERMINALNUMANALYSISRESULT_MODIFYREMARK_RESULT: (state, rst) => {
      state.state_DuplicateTerminalNumAnalysisResult_ModifyRemarkResult = rst;
    },
    SET_DUPLICATETERMINALNUMANALYSISRESULT_ADDPROCESSREMARK_RESULT: (state, rst) => {
      state.state_DuplicateTerminalNumAnalysisResult_AddProcessRemarkResult = rst;
    },
    SET_DUPLICATETERMINALNUMANALYSISRESULT_BATCHADDPROCESSREMARK_RESULT: (state, rst) => {
      state.state_DuplicateTerminalNumAnalysisResult_BatchAddProcessRemarkResult = rst;
    },
  },
  actions: {
    DuplicateTerminalNumAnalysisResultServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_DUPLICATETERMINALNUMANALYSISRESULT_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_DUPLICATETERMINALNUMANALYSISRESULT_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    DuplicateTerminalNumAnalysisResultServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_DUPLICATETERMINALNUMANALYSISRESULT_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_DUPLICATETERMINALNUMANALYSISRESULT_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    DuplicateTerminalNumAnalysisResultServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_DUPLICATETERMINALNUMANALYSISRESULT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_DUPLICATETERMINALNUMANALYSISRESULT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    DuplicateTerminalNumAnalysisResultServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_DUPLICATETERMINALNUMANALYSISRESULT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_DUPLICATETERMINALNUMANALYSISRESULT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    DuplicateTerminalNumAnalysisResultServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_DUPLICATETERMINALNUMANALYSISRESULT_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_DUPLICATETERMINALNUMANALYSISRESULT_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    DuplicateTerminalNumAnalysisResultServ_ModifyRemark({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyRemark(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_DUPLICATETERMINALNUMANALYSISRESULT_MODIFYREMARK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_DUPLICATETERMINALNUMANALYSISRESULT_MODIFYREMARK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    DuplicateTerminalNumAnalysisResultServ_AddProcessRemark({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addProcessRemark(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_DUPLICATETERMINALNUMANALYSISRESULT_ADDPROCESSREMARK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_DUPLICATETERMINALNUMANALYSISRESULT_ADDPROCESSREMARK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    DuplicateTerminalNumAnalysisResultServ_BatchAddProcessRemark({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        batchAddProcessRemark(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_DUPLICATETERMINALNUMANALYSISRESULT_BATCHADDPROCESSREMARK_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_DUPLICATETERMINALNUMANALYSISRESULT_BATCHADDPROCESSREMARK_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_DuplicateTerminalNumAnalysisResult_GetAllResult: state => {
      return state.state_DuplicateTerminalNumAnalysisResult_GetAllResult;
    },
    get_DuplicateTerminalNumAnalysisResult_SearchByNameResult: state => {
      return state.state_DuplicateTerminalNumAnalysisResult_SearchByNameResult;
    },
    get_DuplicateTerminalNumAnalysisResult_GetPageResult: state => {
      return state.state_DuplicateTerminalNumAnalysisResult_GetPageResult;
    },
    get_DuplicateTerminalNumAnalysisResult_GetDetailResult: state => {
      return state.state_DuplicateTerminalNumAnalysisResult_GetDetailResult;
    },
    get_DuplicateTerminalNumAnalysisResult_DeleteObjResult: state => {
      return state.state_DuplicateTerminalNumAnalysisResult_DeleteObjResult;
    },
    get_DuplicateTerminalNumAnalysisResult_ModifyRemarkResult: state => {
      return state.state_DuplicateTerminalNumAnalysisResult_ModifyRemarkResult;
    },
    get_DuplicateTerminalNumAnalysisResult_AddProcessRemarkResult: state => {
      return state.state_DuplicateTerminalNumAnalysisResult_AddProcessRemarkResult;
    },
    get_DuplicateTerminalNumAnalysisResult_BatchAddProcessRemarkResult: state => {
      return state.state_DuplicateTerminalNumAnalysisResult_BatchAddProcessRemarkResult;
    },
  }
}